<script>
export default {
  name: 'PopupViewerMixins',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false,
      isClickingOutside: false,
      hasEvent: false
    }
  },
  methods: {
    handleClickOutside (evt) {
      const isClickingOutside = [...evt.target.classList].some(c => c === 'popup-viewer-wrapper')
      if (!isClickingOutside || this.hasEvent) return
      this.isClickingOutside = isClickingOutside
      this.hasEvent = true
      setTimeout(() => {
        this.isClickingOutside = false
        this.hasEvent = false
      }, 200)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PopupViewerMixins.vue?1892a0b1